import {ILangdict, Langdict} from './langdict';
import {RegistrationRound} from './registration-round';
import {Faculty} from './faculty';
import {environment} from '../../environments/environment';
import {ITokenType, TokenType} from './token-type';
import {CourseGroup, ICourseGroup} from './course-group';
import {Course, ICourse} from './course';
import {Token} from '@angular/compiler';
import {group} from '@angular/animations';

export class IRegistration {
  description: Langdict;
  shortDescription: Langdict;
  rounds: RegistrationRound[];
  id: string;
  status: string;
  message: Langdict;
  isLinkMandatory: boolean;
  faculty?: Faculty;
  registrationType: String;
}

export class Registration extends IRegistration {
  encId: string;

  constructor(obj: IRegistration) {
    super();
    this.description = new Langdict(obj.description);
    this.shortDescription = new Langdict(obj.shortDescription);

    this.rounds = obj.rounds.map(r => new RegistrationRound(r)).sort((a, b) => a.dateFrom > b.dateFrom ? 1 : -1);
    this.id = obj.id;
    this.encId = encodeURIComponent(obj.id);
    this.status = obj.status;
    this.message = new Langdict(obj.message);
    this.isLinkMandatory = obj.isLinkMandatory;
    this.faculty = obj.faculty ? new Faculty(obj.faculty) : undefined;
    this.registrationType = obj.registrationType;
  }

  upcomingRound() {
    return this.rounds.find(round => round.dateTo > new Date());
  }

  get currentRound() {
    return this.rounds.find(round => round.dateFrom <= new Date() && round.dateTo >= new Date())
  }

  get isActiveWithCurrentRound() {
    return this.isOpen();
  }

  get isActiveWithNextRound() {
    return !this.isActiveWithCurrentRound && this.upcomingRound();
  }

  get isInactiveOrFinished() {
    return !this.isActiveWithCurrentRound && !this.isActiveWithNextRound;
  }


  isOpen() {
    return this.status === 'Active' && this.currentRound;
  }

  toString() {
    if (environment.lang === 'pl') {
      return this.shortDescription.pl || this.description.pl || '(brak opisu)';
    } else {
      return this.shortDescription.en || this.description.en || this.shortDescription.pl || this.description.pl || '(missing description)';
    }
  }

  getPathFragment() {
    return [this.id];
  }

  getUsoswebUrl() {
    return environment.usoswebUrl + '/kontroler.php?_action=dla_stud/zetony/index#/registration/' + encodeURIComponent(this.id);
  }
}

export interface IDetailedRegistration extends IRegistration {
  coursesGroups: ICourseGroup[];
  courses: ICourse[];
  tokenPrices: ITokenType[];
}

export class DetailedRegistration extends Registration implements IDetailedRegistration {
  courses: Course[];
  coursesGroups: CourseGroup[];
  tokenPrices: TokenType[];

  constructor(obj: IDetailedRegistration) {
    super(obj);
    this.courses = obj.courses.map(c => new Course(c)).sort((c1, c2) => c1.courseId > c2.courseId ? 1 : -1);
    this.coursesGroups = obj.coursesGroups.map(g => new CourseGroup(g)).sort((a, b) => a.id > b.id ? 1 : -1);
    this.tokenPrices = obj.tokenPrices.map(p => new TokenType(p));
  }

  getCourseGroup(courseGroupId: string) {
    return this.coursesGroups.find(g => g.id === courseGroupId);
  }
}

export class ParticipantsCounter {
  constructor(public data: object) {
  }

  public get(unitId, groupNumber) {
    try {
      return this.data[unitId][groupNumber] || 0;
    } catch (TypeError) {
      return 0;
    }
  }
}
